<template>
  <div>
    <h1>Dashboard</h1>

    <!--vo-basic :data="chartData" :draggable="false"></vo-basic-->
  </div>
</template>

<script>
import { VoBasic } from 'vue-orgchart';
export default {
  name: 'Dashboard',
  data() {
    return {
      title: 'Dashboard RH',
    };
  },
  components: { VoBasic },
  created() {
    this.chartData = {
      name: 'JavaScript',
      children: [
        { name: 'Angular' },
        {
          name: 'React',
          children: [{ name: 'Preact' }],
        },
        {
          name: 'Vue',
          children: [{ name: 'Moon' }],
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
};
</script>

<style scoped></style>
